module.exports = __webpack_public_path__ + "static/media/confetti.8db5efdb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gifs/confetti.gif
// module id = 884
// module chunks = 0